import { useState, useEffect } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter, SheetClose } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useTranslation } from 'react-i18next';

export default function SheetBilling({ open, onClose, billingInfo, onSave, isSubmitting = false }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        fullName: billingInfo?.fullName || '',
        address: billingInfo?.address || '',
        email: billingInfo?.email || '',
        phone: billingInfo?.phone || '',
    });

    // Mettre à jour le formulaire quand billingInfo change
    useEffect(() => {
        setFormData({
            fullName: billingInfo?.fullName || '',
            address: billingInfo?.address || '',
            email: billingInfo?.email || '',
            phone: billingInfo?.phone || '',
        });
    }, [billingInfo]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave?.(formData);
        onClose();
    };

    const handleChange = (field) => (e) => {
        setFormData((prev) => ({ ...prev, [field]: e.target.value }));
    };

    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent side="right" className="w-[90vw] md:w-[500px]! md:max-w[500px]!">
                <SheetHeader>
                    <SheetTitle>{t('tokens:modifierLesInformationsDeFacturation')}</SheetTitle>
                </SheetHeader>

                <form onSubmit={handleSubmit} className="space-y-4 mt-6">
                    <div className="space-y-2">
                        <Label htmlFor="fullName">{t('tokens:nomComplet')}</Label>
                        <Input
                            id="fullName"
                            value={formData.fullName}
                            onChange={handleChange('fullName')}
                            placeholder={t('tokens:prenomNom')}
                        />
                    </div>

                    <div className="space-y-2">
                        <Label htmlFor="address">{t('tokens:adresseComplete')}</Label>
                        <Input
                            id="address"
                            value={formData.address}
                            onChange={handleChange('address')}
                            placeholder={t('tokens:adresseCodePostalVille')}
                        />
                    </div>

                    <div className="space-y-2">
                        <Label htmlFor="email">{t('tokens:email')}</Label>
                        <Input
                            id="email"
                            type="email"
                            value={formData.email}
                            onChange={handleChange('email')}
                            placeholder="email@exemple.com"
                        />
                    </div>

                    <div className="space-y-2">
                        <Label htmlFor="phone">{t('tokens:telephone')}</Label>
                        <Input
                            id="phone"
                            type="tel"
                            value={formData.phone}
                            onChange={handleChange('phone')}
                            placeholder="06 00 00 00 00"
                        />
                    </div>

                    <SheetFooter className="mt-6">
                        <SheetClose asChild>
                            <Button type="button" variant="soft" color="neutral">
                                {t('tokens:annuler')}
                            </Button>
                        </SheetClose>
                        <SubmitButton isSubmitting={isSubmitting} loadingText={t('tokens:enregistrement')}>
                            {t('tokens:enregistrer')}
                        </SubmitButton>
                    </SheetFooter>
                </form>
            </SheetContent>
        </Sheet>
    );
}
